export function createChainOfHandlersFor<T>(handlers: ((state: T) => T)[]): (state: T) => T {
  return (state: T) => {
    return handlers.reduce((acc, curr) => curr(acc), state);
  };
}